import { BuilderElementType } from '@website-builder/model/domain/builder-element-type.enum';

import { Section } from '@website-builder/model/structure/section/section';
import { EditableComponent } from '@website-builder/model/structure/editable-component.interface';
import { BuilderElementPosition } from '@website-builder/model/structure/builder-element-position';
import { TbUtility } from '@website-builder/util/tb-utility';
import { BuilderRootStructureType } from '@website-builder/model/state/builder-root-structure.type';

export class Footer implements EditableComponent {
  readonly type: BuilderRootStructureType = BuilderElementType.Footer;
  builderElementPosition: BuilderElementPosition;

  id = TbUtility.randomIdAsNumber;
  title = '';
  sections: Section[] = new Array<Section>();
  previewUrl = 'assets/images/no-preview-available.jpg';

  static normalizeInPlace(footer: Partial<Footer>): Footer {
    const pureFooter = new Footer();

    footer.id = footer.id ?? pureFooter.id;
    footer.title = footer.title ?? pureFooter.title;
    footer.sections = (footer.sections ?? []).map(section => Section.normalizeInPlace(section));
    footer.previewUrl = footer.previewUrl ?? pureFooter.previewUrl;

    return footer as Footer;
  }
}
